import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { publicWorkflow, workflowError } from '../utils/electionWorkflows';

export default function NominationConfirm() {
  const [token] = useState(() => window.location.hash.slice(1));
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      const response = await publicWorkflow('nomination-confirm', { token });
      setMessage(response.data.message);
    } catch (err) { setError(workflowError(err)); }
    finally { setBusy(false); }
  };
  return <main className="container py-5" style={{ maxWidth: 700 }}>
    <Link to="/">VoteWave</Link>
    <h1 className="mt-3">Confirm your nomination</h1>
    <p>Click below to verify your email and count the nomination you submitted. This does not cast a vote.</p>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {message ? <div className="alert alert-success" role="status">{message}</div>
      : <button className="btn btn-primary" onClick={confirm} disabled={busy || !token}>
        {busy ? 'Confirming...' : 'Confirm nomination'}
      </button>}
    {!token && <p role="alert">No confirmation token found. Open the complete link from your email.</p>}
  </main>;
}
